function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cancel__circle",
    fill: "#fff",
    style: {
      fill: "var(--background-color, #fff)"
    },
    d: "M15.998 32C24.839 32 32 24.84 32 15.998 32 7.16 24.84 0 15.998 0 7.165 0 0 7.16 0 15.998 0 24.839 7.165 32 15.998 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cancel",
    style: {
      fill: "var(--icon-color, #000)"
    },
    d: "M16 5c6.075 0 11 4.925 11 11s-4.925 11-11 11S5 22.075 5 16 9.925 5 16 5zM8.667 16a7.333 7.333 0 0011.058 6.318L9.682 12.275A7.3 7.3 0 008.667 16zM16 8.667a7.3 7.3 0 00-3.725 1.015l10.043 10.043A7.333 7.333 0 0016 8.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.8dafedd903d5fc091d203703727690a3.svg";
export { ForwardRef as ReactComponent };